export interface Devices {
  id: string;
  assigned_date: Date;
  device_id: string;
  name: string;
  purchase_date: Date;
  status: string;
  update_time: Date;
  user_info?: {
    name: string;
    phone: string;
    email: string;
    profile_picture: string;
  };
  warranty_date: Date;
}

export interface DeviceTableProps {
  devices: Devices[];
  onEdit: (deviceId: string) => void;
  onDelete: (deviceId: string) => void;
}

const formatStatus = (status: string) => {
  switch (status) {
    case 'available':
      return 'Available';
    case 'damaged':
      return 'Damaged';
    case 'in_repair':
      return 'In Repair';
  }
};

export const addDeviceFields = (
  t: any,
  data: any = {},
  assignUserOption: any[]
) => [
  {
    label: t('add-device.device-id'),
    type: 'text',
    name: 'device_id',
    isRequired: true,
  },
  {
    label: t('add-device.device-name'),
    type: 'text',
    name: 'name',
    isRequired: true,
  },
  {
    label: t('add-device.status'),
    type: 'select',
    name: 'status',
    options: assignUserOption,
    isRequired: false,
  },
  {
    label: t('add-device.purchase'),
    type: 'date',
    name: 'purchase_date',
    isRequired: false,
  },
  {
    label: t('add-device.warranty'),
    type: 'date',
    name: 'warranty_date',
    isRequired: false,
  },
];

export const editDeviceFields = (
  t: any,
  data: any = {},
  assignUserOption: any[]
) => [
  {
    label: t('edit-device.device-id'),
    type: 'text',
    name: 'device_id',
    isRequired: true,
    value: data.device_id,
  },
  {
    label: t('edit-device.device-name'),
    type: 'text',
    name: 'name',
    isRequired: true,
    value: data.name,
  },
  {
    label: t('edit-device.status'),
    type: 'select',
    name: 'status',
    options: assignUserOption,
    isRequired: false,
    value: data.status,
  },
  {
    label: t('edit-device.purchase'),
    type: 'date',
    name: 'purchase_date',
    isRequired: false,
    value: data.purchase_date,
  },
  {
    label: t('edit-device.warranty'),
    type: 'date',
    name: 'warranty_date',
    isRequired: false,
    value: data.warranty_date,
  },
];

export const deleteDeviceFields = (t: any, data: any = {}) => [
  {
    label: t('delete-device.device-id'),
    name: 'device_id',
    value: data.device_id,
  },
  {
    label: t('delete-device.device-name'),
    name: 'device_name',
    value: data.name,
  },
  {
    label: t('delete-device.status'),
    name: 'status',
    value: data.user ? data.user_info.name : formatStatus(data.status),
  },
];
